module.exports = {
      id: "ic-crosshair-on-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-dbc6d5.smartcharts.svg#ic-crosshair-on-usage",
      toString: function () {
        return this.url;
      }
    }